import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import {
	sortAscIcon,
	sortDescIcon,
} from "@tql/ui-components-react/kendo/svg-icons";
import type { DropDownListProps } from "@tql/ui-components-react/tql/dropdowns";
import { DropDownList } from "@tql/ui-components-react/tql/dropdowns";
import React, { useState } from "react";

export type SortDirection = "asc" | "desc";

type SortDropdownProps = Omit<DropDownListProps, "valueRender"> & {
	initialSortDirection?: SortDirection;
	onSortDirectionChange?: (direction: SortDirection) => void;
};

export const SortDropdown = ({
	initialSortDirection = "desc",
	onSortDirectionChange,
	...props
}: SortDropdownProps) => {
	const [sortDirection, setSortDirection] =
		useState<SortDirection>(initialSortDirection);

	const handleSortIconClick = (event: React.MouseEvent<HTMLOrSVGElement>) => {
		event.stopPropagation();
		const newDirection: SortDirection =
			sortDirection === "asc" ? "desc" : "asc";
		setSortDirection(newDirection);
		onSortDirectionChange?.(newDirection);
	};

	const valueRender = (
		element: React.ReactElement<HTMLSpanElement>,
		value: unknown,
	) => {
		if (!value) {
			return element;
		}

		const sortIcon = sortDirection === "asc" ? sortAscIcon : sortDescIcon;

		const children = [
			<SvgIcon
				key={1}
				icon={sortIcon}
				onClick={handleSortIconClick}
				style={{ cursor: "pointer", userSelect: "none" }}
			/>,
			<span key={2}>&nbsp; {element.props.children as React.ReactNode}</span>,
		];

		return React.cloneElement(element, { ...element.props }, children);
	};

	return <DropDownList {...props} valueRender={valueRender} />;
};
